import { useDispatch } from "react-redux";
import API from "../api";
import { setToken, setUser, setSub, expVidPopup, setPasswordPopup, setRegionAccess } from "action/index.js";
import { useNavigate } from "react-router-dom";
import { clearOnboardingData } from "components/WebsiteTour/tourData";

const useLogOut = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logout = async () => {
    let response = await API({
      method: "POST",
      url: "logout",
    });

    if (response.status && response.status === 200) {
      dispatch(setToken(null));
      dispatch(setUser(null));
      dispatch(setSub(false));
      dispatch(expVidPopup(0));
      dispatch(setPasswordPopup(false));
       dispatch(setRegionAccess(true));
       clearOnboardingData();
      navigate("/auth/login?logout");
    }
  };

  const logoutDirectly = () => {
    dispatch(setToken(null));
    dispatch(setUser(null));
    dispatch(setSub(false));
    dispatch(expVidPopup(0));
    dispatch(setPasswordPopup(false));
     dispatch(setRegionAccess(true));
     clearOnboardingData();
    navigate("/auth/login");
  };

  return { logout, logoutDirectly };
};

export default useLogOut;
